import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideTable } from "../../components/ShowHideTable";
import SubHeaderBox from "../../components/SubHeaderBox";
import InventoryMachineryTable from "./Table";
import { getSystemBoundarySubcategory } from "../../../../../apis/Business/InventoryApi";
import inventoryMachineryIcon from "../../../../../assets/design-revamp-company/category-icons/inventory_machine_icon.svg";
const InventoryMachinery = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [systemBoundaryMachinery, setSystemBoundaryMachinery] = useState();
  useEffect(() => {
    getSystemBoundarySubcategory({
      businessId: businessId,
      setSystemBoundarySubCategory: setSystemBoundaryMachinery,
      subcategory: "machinery",
    });
  }, [businessId]);

  return (
    <div className="component-energy-contents">
      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SubHeaderBox
            subTitle={t("MACHINERY")}
            subDescription={t("DESC_INV_MACHINE")}
            isNormal={true}
            number={"5.1.2"}
            icon={inventoryMachineryIcon}
            showSystemBoundary={true}
            systemBoundaryProps={{
              businessId: businessId,
              systemBoundary: systemBoundaryMachinery,
              setSystemBoundary: setSystemBoundaryMachinery,
              totalObjCategory: "machinery",
              customStyles: { marginTop: "10px" },
              isInventory: true,
            }}
          />
        </div>

        {showTable && <InventoryMachineryTable businessId={businessId} />}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
    </div>
  );
};

export default InventoryMachinery;
